import { TranslateService } from '@ngx-translate/core';
import { TranslateHelper } from './../../_helpers/translate-helper';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BlockHeaderGroup } from '@app/_interfaces/block-header-group';
import { DirectionService } from '@app/_services/direction.service';
import * as _ from 'lodash';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';


interface ISectorSection {
    name?: {
        en?: string,
        ar?: string
    },
    seo?: {
        slug: string
    }
    image?: any,
    mainButton?: {
        en?: string,
        ar?: string
    },
    secondaryButton?: {
        en?: string,
        ar?: string,
    },
    description?: {
        en?: string,
        ar?: string,
    }
}

@Component({
    selector: 'app-block-sector-section',
    templateUrl: './block-sector-section.component.html',
    styleUrls: ['./block-sector-section.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [RouterLink, MatIconModule]
})


export class BlockSectorSectionComponent implements OnInit, OnChanges {
    constructor(
        public translateHelper: TranslateHelper,
        private direction: DirectionService,
        private translate: TranslateService
    ) { }

    ngOnInit(): void {
        // console.log(this.sector?.name);
    }

    @Input() sector: ISectorSection;

    ngOnChanges(changes: SimpleChanges): void {

    }

    getSectorUrl() {
        return [
            '/sector',
            this.sector?.seo?.slug
        ];
    }
}
